import { CapoPlugin } from "/__w/landing-page/landing-page/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];